<script setup lang="ts">
import type { TopicMeta } from '../../types/topic-meta'

const route = useRoute()
const { loggedIn } = useUserSession()

const { data: topLevelTopics } = await useFetch<TopicMeta[]>('/api/topics', {
  default: () => []
})

const visibleTopLevelTopics = computed(() => loggedIn.value ? (topLevelTopics.value || []) : (topLevelTopics.value || []).filter(topic => !topic.hidden))

function isTopicActive(topicName: string) {
  return route.path === `/topics/${topicName}` || route.path.startsWith(`/topics/${topicName}/`)
}
</script>

<template>
  <BottomMenu position="top">
    <template #logo>
      <div class="flex items-center gap-3">
        <NuxtLink
          to="/"
          class="inline-flex items-center"
          aria-label="Back to home"
        >
          <img
            src="/logo.png"
            width="38"
            height="38"
          >
          <p class="text-base sm:text-base font-bold leading-tight sm:leading-normal text-white whitespace-nowrap">
            Analog Anonymous
          </p>
        </NuxtLink>
      </div>
    </template>
    <template #separator>
      <span class="h-5 w-px bg-white/30 shrink-0" />
    </template>

    <template #menulinks>
      <div class="max-w-[60vw] overflow-x-auto no-scrollbar">
        <nav class="inline-flex items-center gap-2 whitespace-nowrap">
          <NuxtLink
            v-for="topic in visibleTopLevelTopics"
            :key="topic.id"
            :to="`/topics/${topic.name}`"
            class="text-xs px-2 py-1 rounded transition-colors"
            :class="isTopicActive(topic.name) ? 'text-white bg-white/20' : 'text-gray-300 hover:text-white hover:bg-white/10'"
          >
            {{ topic.title }}
          </NuxtLink>
        </nav>
      </div>
    </template>
  </BottomMenu>
</template>
